export default "__VITE_ASSET__Y03_j8h5__"